import { colors } from '@constants/colors';

import TransitionScreenBg from '@public/images/087b2dc3187c09ffe444273797eae2f1348629b4.jpg';

export const useStyles = () => {
  return {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 99999,
      pointerEvents: 'auto',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      overscrollBehaviorY: 'contain',
      backgroundImage: `url(${TransitionScreenBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',

      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1,
    },
    title: {
      fontSize: 48,
      fontFamily: 'Primary-Bold',
      marginTop: 5.5,
    },
    text: {
      fontSize: 20,
      fontWeight: 500,
      color: colors.grey_third,
      maxWidth: 640,
      textAlign: 'center',
    },
  };
};
